import { useSelector } from 'react-redux';
import { selectFilters } from '../selectors';
import { EventsFilter } from '../interfaces';

export const useFilter = (): EventsFilter => {
  const filter = useSelector(selectFilters);

  return filter;
};
